// extracted by mini-css-extract-plugin
export default {"wrapper":"MenuItem_wrapper__39rOX","iconContainer":"MenuItem_iconContainer__YO9gz"};